import {URMRole, URMRoleKey, URMRoles} from "@/models/dto/userRoleManagement";

/**
 * Represents a user role with its display and behavioral properties
 * @property label - Display name of the role
 * @property key - Unique identifier for the role
 * @property description - Detailed explanation of the role's permissions
 * @property disabled - Whether this role is currently selectable
 */
export interface UserRole {
  label: string
  key: URMRoleKey
  description: string
  disabled: boolean
}

export const AdminUserRole: UserRole = urmRoleToUserRole(URMRoles.AccountAdmin)
export const AuthorizedUserRole: UserRole = urmRoleToUserRole(URMRoles.AccountAuthorizedUser)

function urmRoleToUserRole(urmRole: URMRole): UserRole {
  return {
    ...urmRole,
    disabled: false
  }
}
